module.exports = __webpack_public_path__ + "img/book_of_conjuration_small.6783bf0c.png";